var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconeContrat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n\n      .cls-2, .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 102,
    y: 87.9,
    width: 296,
    height: 324
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M229,307.2h-78c-3,0-5.5-2.4-5.5-5.5s2.4-5.5,5.5-5.5h78c3,0,5.5,2.4,5.5,5.5s-2.5,5.5-5.5,5.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M307.1,258.7h-156.1c-3,0-5.5-2.4-5.5-5.5s2.4-5.5,5.5-5.5h156.1c3,0,5.5,2.4,5.5,5.5s-2.4,5.5-5.5,5.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M307.1,209.6h-156.1c-3,0-5.5-2.4-5.5-5.5s2.4-5.5,5.5-5.5h156.1c3,0,5.5,2.4,5.5,5.5s-2.4,5.5-5.5,5.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M307.1,159.9h-156.1c-3,0-5.5-2.4-5.5-5.5s2.4-5.5,5.5-5.5h156.1c3,0,5.5,2.4,5.5,5.5s-2.4,5.5-5.5,5.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M381.5,293.8l-73.1,60.6c-1.2,1-5.8,2.3-8.1-1.3l-24.8-40c-2.4-3.8-1.7-8.9,1.6-11.3,5.5-4,9.7-1.6,11.9,2.2l11.9,19.2c1.7,2.7,4.4,4.5,7.5,5,3.1.5,6.3-.4,8.7-2.4l53.8-44.6c3.5-2.9,8.7-2.4,11.5,1.1,2.9,3.5,2.4,8.7-1.1,11.5ZM343.7,380.9c0,9-7.3,16.4-16.4,16.4h-196.6c-9,0-16.4-7.3-16.4-16.4V118.9c0-9,7.3-16.4,16.4-16.4h196.6c9,0,16.4,7.3,16.4,16.4v170.8l-33.4,27.7-11.9-19.2c-2.8-4.6-7.5-7.7-12.8-8.7-5.3-1-10.8.4-15.1,3.6-7.7,5.9-9.6,17.2-4.3,25.8l24.8,40c2.5,4,6.6,7,11.3,7.5,5.8.7,10.1-1.1,13.1-3.6l28.3-23.4v41.5ZM391,275.3c-6.7-8.1-18.8-9.2-26.9-2.5l-9.5,7.9V118.9c0-15-12.2-27.3-27.3-27.3h-196.6c-15,0-27.3,12.2-27.3,27.3v261.9c0,15,12.2,27.3,27.3,27.3h196.6c15,0,27.3-12.2,27.3-27.3v-50.6l33.9-28.1c8.1-6.7,9.2-18.8,2.5-26.9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeContrat);
export default __webpack_public_path__ + "static/media/Icone_contrat.1ab71e2d10708ee8c93547c4a68b71d7.svg";
export { ForwardRef as ReactComponent };